import React from 'react';
import {Box} from '@mui/material';
import {CustomTextField} from "../../../../../components/CustomTextField";
import {CustomSelect} from "../../../../../components/CustomSelect";
import {CustomDatePicker} from "../../../../../components/CustomDatePicker";
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import {CleanIcon} from '../../../../../components/buttons/IconButtons';
import {CECO_CODE_NAME, CECO_LENGTH} from "../Model/Models";
import {useTranslation} from "react-i18next";

const Step3EmployeeContract = ({
    employeeData,
    onChange,
    employeeRoles,
    employeeWorkStations,
    employeeDepartments,
    emptyFields,
    isValidEndDate,
    setIsValidEndDate,
    handleClearEmployeeData,
    isPilgrimsValidation,
    isValidCecoCode,
    disable
}) => {

    const {t} = useTranslation();

    return (
        <div className={'row mt-4'}>
                {(employeeData?.id === null || employeeData?.id === '') && (
                    <div className='col-12 d-flex justify-content-end mb-2'>
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_s3ec_clean_form'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            onClick={() => {
                                handleClearEmployeeData();
                            }}
                            iconProps={'btn-icon-svg-12px icon-color-general-00'}
                        />
                    </div>
                )}
                 <div className={'row mt-4'}>
                    <Box className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomSelect disabled={disable} id={"slt_s3ec_privilege"}
                                      name={"roleId"}
                                      value={employeeData.roleId}
                                      selectedKey={employeeData.roleId}
                                      keyName="id"
                                      onChange={onChange}
                                      list={employeeRoles}
                                      trans={"privilege"}
                                      label={"lbl_s3ec_privilege"}
                                      emptyFields={emptyFields}
                                      required={true}
                                      showNoSelectionOption={false}
                        />
                    </Box>

                    <Box className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomTextField disabled={disable} id={"slt_s3ec_employee_id"}
                                         length={128}
                                         name={"employeeId"}
                                         value={employeeData.employeeId}
                                         trans={"employee_id"}
                                         type={"text"}
                                         onChange={onChange}
                                         emptyFields={emptyFields}
                                         required={true}
                        />
                    </Box>

                    <Box className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomTextField disabled={disable} id={"slt_s3ec_ceco_code"}
                                         length={CECO_LENGTH.MAX}
                                         name={CECO_CODE_NAME}
                                         value={employeeData.cecoCode}
                                         trans={"ceco"}
                                         type={"text"}
                                         onChange={onChange}
                                         required={false}
                                         helperText={t('enter_x_characters', {min: CECO_LENGTH.MIN, max: CECO_LENGTH.MAX})}
                                         isValid={isValidCecoCode}
                                         isValidText={t('enter_x_characters', {min: CECO_LENGTH.MIN, max: CECO_LENGTH.MAX})}
                        />
                    </Box>

                    <Box className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomSelect disabled={disable} id={"slt_s3ec_workStation"}
                                      name={"zoneId"}
                                      value={employeeData.zoneId}
                                      selectedKey={employeeData.zoneId}
                                      keyName="id"
                                      onChange={onChange}
                                      list={employeeWorkStations}
                                      trans={"work_station"}
                                      label={"lbl_s3ec_privilege"}
                                      required={false}/>
                    </Box>
                    <Box className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomSelect disabled={disable} id={isPilgrimsValidation ? 'slt_s3ec_work_group' : 'slt_s3ec_department'}
                                      name={"departmentId"}
                                      value={employeeData.departmentId}
                                      selectedKey={employeeData.departmentId}
                                      keyName="id"
                                      onChange={onChange}
                                      list={employeeDepartments}
                                      trans={isPilgrimsValidation ? 'work_group' : 'department'}
                                      label={isPilgrimsValidation ? 'lbl_s3ec_work_group' : 'lbl_s3ec_department'}
                                      emptyFields={emptyFields && isPilgrimsValidation}
                                      required={isPilgrimsValidation}
                                      showNoSelectionOption={!isPilgrimsValidation}/>

                    </Box>

                    <Box className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomTextField disabled={disable} id={"txt_s3ec_hourly_rate"}
                                         length={10}
                                         name={"hourlyRate"}
                                         value={employeeData.hourlyRate ?? ''}
                                         trans={"hourly_rate"}
                                         type={"text"}
                                         onChange={onChange}
                                         required={false}
                                         decimals={2}
                                         suffixText={<p className={"ibl-font-w-600 text-uppercase"}>$</p>}
                        />
                    </Box>

                    <Box className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomDatePicker id={"dp_s3ec_start_date"}
                                          name={'startDate'}
                                          disabled={disable}
                                          onChange={(e)=>{
                                              onChange({ target: { value: e, name: 'startDate' } });
                                          }}
                                          trans={"start_date"}
                                          value={employeeData.startDate}
                                          required={true}
                                          emptyFields={emptyFields}
                                          disableFuture={false}
                                          openTo={"day"}
                        />
                    </Box>
                    <Box className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomDatePicker id={"dp_s3ec_end_date"}
                                          name={'endDate'}
                                          disabled={disable || employeeData.startDate === null}
                                          onChange={(e)=>{
                                              onChange({ target: { value: e, name: 'endDate' } });
                                          }}
                                          trans={"end_date"}
                                          value={employeeData.endDate}
                                          required={false}
                                          disableFuture={false}
                                          openTo={"day"}
                                          helperText={"please_leave_this_field_empty_if_the_contract_duration_is_indefinite"}
                                          minDate={employeeData.startDate}
                                          isValid={isValidEndDate}
                                          onError={(error) => {
                                              setIsValidEndDate(error === null)
                                          }}
                        />
                    </Box>
                </div>
        </div>
    );
};

export default Step3EmployeeContract;
